<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        :items="theFornecedores"
        :error-messages="errors"
        :value="value"
        :label="label"
        :prepend-icon="icon"
        :search-input.sync="search"
        item-text="trade_name"
        return-object
        @input="$emit('input', $event)"
        @keyup="customChange($event, handleGetFornecedores)"
        no-filter
        :loading="calling"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.trade_name"></v-list-item-title>
            <v-list-item-subtitle
              v-text="`CNPJ ${item.cnpj} - ${item.city} - ${item.district}`"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import GatesApi from '@/services/tenants/gates'
import { customChange } from '@/mixins/autocomplete.js'

export default {
  name: 'RelatorioCargaDescargaListFiltroModalItemInputFornecedor',
  mixins: [customChange],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      fornecedoresSelecionados: [],
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual', 'user']),
    theFornecedores() {
      if(this.value){
        return [this.value].concat(this.fornecedoresSelecionados.filter(c => this.value.public_id != c.public_id))
      }
      return this.fornecedoresSelecionados
    },
  },
  methods: {
    async handleGetFornecedores(event) {
      const value = event.target.value
      await this.getFornecedorSearch({
        pesquisa: value,
      })
    },
    async getFornecedorSearch(parametros) {
      try {
        const fornecedor = await GatesApi.getFornecedoresByParams(
          this.empresaAtual,
          parametros
        )

        this.fornecedoresSelecionados = fornecedor
      } catch (e) {
        console.log(e)
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        }
      }
    },
  },
}
</script>
